import React from 'react';
import { Alert, List, Statistic } from 'antd';
import FollowUpsPanel from '../review/FollowUpsPanel.jsx';

export default function ResultsStep({ result }) {
  const { successful_records: ok = 0, failed_records: failed = 0,
          failed_items: failures = [], follow_ups: followUps = [] } = result || {};

  return (
    <div>
      <Statistic title="Records created" value={ok} />

      {failed > 0 && (
        <Alert
          type="error"
          showIcon
          message={`${failed} record(s) failed`}
          description={
            <List
              size="small"
              dataSource={failures}
              renderItem={(f) => <List.Item><strong>{f.name}</strong> — {f.error}</List.Item>}
            />
          }
        />
      )}

      <FollowUpsPanel followUps={followUps} />
    </div>
  );
}
